import React from 'react';
import styled from 'styled-components';
import Jello from 'react-reveal/Jello';
import PText from './PText';
import Button from './Button';
import HorizontalLine from './HorizontalLine';

const ContactBannerStyles = styled.div`
  padding: 10rem 0;

  .contactBanner__wrapper {
    background-color: var(--deep-dark);
    border-radius: 12px;
    text-align: center;
    padding: 5rem 0rem;
  }
  .contactBanner__heading {
    font-size: 4rem;
    margin-bottom: 2rem;
  }

  @media only screen and (max-width: 768px) {
    .contactBanner__heading {
      font-size: 2.8rem;
    }
  }
`;
export default function ContactBanner() {
  return (
    <ContactBannerStyles>
      <HorizontalLine />
      <div className="container">
        <div className="contactBanner__wrapper">
          <Jello>
            <PText>Have a project in mind</PText>
            <h3 className="contactBanner__heading">Let me help you</h3>
            <Button btnText="Contact Now" btnLink="/contact" />
          </Jello>
        </div>
      </div>
    </ContactBannerStyles>
  );
}
